import { getService, postService } from '../api/service.js'

// 套票销售统计总览
export const ComDistributorIDTotalSales = params => {
  return postService('api/combo/ComDistributorIDTotalSales', params)
}

// 套票销售日期统计列表
export const ComScenicDisSellTJ = params => {
  return postService('api/combo/ComScenicDisSellTJ', params)
}

// 套票销售产品统计列表
export const ComScenicDisSellOneTJ = params => {
  return postService('api/combo/ComScenicDisSellOneTJ', params)
}

// 套票销售详情列表
export const ComgetScenicOrderListNew = params => {
  return postService('api/combo/ComgetScenicOrderListNew', params)
}

// 套票销售产品导出
export const ComScenicDisSellOneExport = params => {
  return postService('api/combo/ComScenicDisSellOneExport', params)
}

// 套票销售日期统计导出
export const ComexportDistributorSalesStatistics = params => {
  return postService('api/combo/ComexportDistributorSalesStatistics', params)
}

// 套票销售详情导出
export const ComScenicPostExport = params => {
  return getService('api/combo/ComScenicPostExport', params)
}

// 套票退票详情列表
export const ScenicDisRefundTJXQ = params => {
  return postService('api/combo/ComScenicDisRefundTJXQ', params)
}

// 套票退款产品统计
export const ComDisProductRefundTotal = params => {
  return postService('api/combo/ComDisProductRefundTotal', params)
}

// 套票退票自然日统计
export const ComScenicDisRefundTJ = params => {
  return postService('api/combo/ComScenicDisRefundTJ', params)
}

// 套票退票统计总览
export const ComDistributorRefundGeneralLedger = params => {
  return postService('api/combo/ComDistributorRefundGeneralLedger', params)
}

// 套票退款产品统计导出
export const ComDisProductRefundExport = params => {
  return postService('api/combo/ComDisProductRefundExport', params)
}

// 套票退款日期统计导出
export const DistributorIDRefundDateExport = params => {
  return postService('api/combo/ComDistributorIDRefundDateExport', params)
}

// 套票退款详情导出
export const RefundTJXQExport = params => {
  return postService('api/combo/ComRefundTJXQExport', params)
}

// 套票核销统计总览
export const DistributorIDVerifiGeneralLedger = params => {
  return postService('api/combo/ComDistributorIDVerifiGeneralLedger', params)
}

// 套票核销订单详情列表
export const ComScenicDisTicketTJXQ = params => {
  return postService('api/combo/ComScenicDisTicketTJXQ', params)
}

// 套票核销日期统计列表
export const ComScenicDisTicketTJ = params => {
  return postService('api/combo/ComScenicDisTicketTJ', params)
}

// 套票核销产品统计列表
export const ComDisProductVerifiTotal = params => {
  return postService('api/combo/ComDisProductVerifiTotal', params)
}

// 套票核销日期统计导出
export const ComScenicDisTicketTJExport = params => {
  return postService('api/combo/ComScenicDisTicketTJExport', params)
}

// 套票核销产品统计导出
export const ComDisProductVerifiExport = params => {
  return postService('api/combo/ComDisProductVerifiExport', params)
}

// 套票核销详情导出
export const ScenicDisTicketTJXQExport = params => {
  return postService('api/combo/ComScenicDisTicketTJXQExport', params)
}

